import { Container } from 'hypo-container';
import { IAppConfig } from '@estee/elc-universal-utils';
import { BusinessUnitIdParser } from '@estee/elc-formatters';
import { HttpTransport } from '@estee/elc-http-transport';

import { IOffersViewController } from '~exported/cart-sidebar-cart-offers/OffersViewController/IOffersViewController';
import { OffersViewController } from '~exported/cart-sidebar-cart-offers/OffersViewController/OffersViewController';
import OffersRepository from '~repositories/OffersRepository/OffersRepository';
import { IOffersRepositoryProps } from '~repositories/OffersRepository/IOffersRepository';
import ConfigRepository from '~repositories/ConfigRepository/ConfigRepository';
import CartOffers from '~domain/entities/CartOffers/CartOffers';
import { OffersService, serviceNames } from '~setup/OffersService';
import Config from '~domain/entities/Config/Config';
import OfferCodeModuleViewController from '~exported/offer-code-module/OfferCodeModuleController';
import { SamplesRepository } from '~repositories/SamplesRepository/SamplesRepository';
import { SamplesController } from '~exported/samples-component/SamplesController';
import { CartRepository } from '~repositories/CartRepository/CartRepository';
import { OffersTabStartedUseCase } from '~use-cases/OffersTabStartedUseCase';
import { IOffersServiceConfigs } from '../internal/domain/entities/Config/IConfig';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

export const serviceInitializer = async (config: IAppConfig) => {
    setConfig(config);

    const useCase = new OffersTabStartedUseCase({
        appConfig: config as IOffersServiceConfigs['appConfig'],
        buidConfig: ['language', 'brand.id', 'region']
    });

    await useCase.execute();
};

diContainer
    .register(serviceNames.configRepository, (c) =>
        new ConfigRepository({ configEntity: c.get(serviceNames.config) })
    )
    .register(serviceNames.samplesRepository, () => new SamplesRepository())
    .register(serviceNames.httpTransport, () => new HttpTransport())
    .register(serviceNames.config, (c) => new Config(c.config))
    .register(
        serviceNames.businessUnitIdParser,
        diContainer.factory(({ config }) => new BusinessUnitIdParser(config.businessUnitId))
    )
    .register(serviceNames.cartOffers, () => new CartOffers())
    .register(serviceNames.offersRepository, (c) => {
        const payload: IOffersRepositoryProps = {
            cartOffers: c.get(serviceNames.cartOffers)
        };

        return new OffersRepository(payload);
    })
    .register(serviceNames.offersViewController, (c) => {
        const payload: IOffersViewController = {
            offersRepository: c.get(serviceNames.offersRepository)
        };

        return new OffersViewController(payload);
    })
    .register(serviceNames.offersService, () => new OffersService(serviceInitializer))
    .register(
        serviceNames.offerCodeModuleViewController,
        (c) =>
            new OfferCodeModuleViewController({
                offersRepository: c.get(serviceNames.offersRepository)
            })
    )
    .register(serviceNames.cartRepository, () => new CartRepository())
    .register(
        serviceNames.samplesController,
        (c) =>
            new SamplesController({
                samplesRepository: c.get(serviceNames.samplesRepository),
                cartRepository: c.get(serviceNames.cartRepository),
                offersRepository: c.get(serviceNames.offersRepository)
            })
    );

